export default __webpack_public_path__ + "static/media/boss.ae714d79.png";